import styled from "@emotion/styled";
import { css } from "@emotion/react";

interface NewHeaderBarProps {
  variant?: "white" | "black" | "gradient";
}

export default function NewHeaderBar({ variant = "gradient" }: NewHeaderBarProps) {
  return (
    <Styled.Container variant={variant}>
      {/* Empty container with just the background */}
    </Styled.Container>
  );
}

/* Styled Components
======================================================= */
const Styled: any = {};

const getBackgroundStyles = (variant: string, t: any) => {
  switch (variant) {
    case "white":
      return css`
        background: ${t.color.white};
      `;
    case "black":
      return css`
        background: ${t.color.gray[900]};
      `;
    case "gradient":
      return css`
        background: linear-gradient(106.26deg, #fbd7ff 4.26%, #ffe4cc 95.3%, #ffdec1 95.3%);
      `;
    default:
      return css`
        background: linear-gradient(106.26deg, #fbd7ff 4.26%, #ffe4cc 95.3%, #ffdec1 95.3%);
      `;
  }
};

Styled.Container = styled.div<{ variant: string }>((props) => {
  const t: any = props.theme;

  return css`
    label: NewHeaderBar;
    position: sticky;
    top: 0;
    width: 100%;
    height: 46px;
    ${getBackgroundStyles(props.variant, t)};
    z-index: 10;
  `;
});
